let nextButton = document.querySelector(".custom-product-form-next");
let newnextButton = document.querySelector(".custom-product-form-next-new");
let mql = window.matchMedia("(max-width: 768px)");
let step1 = document.querySelector(".step-1");
let step2 = document.querySelector(".step-2");
let step3 = document.querySelector(".step-3");
let statusEl = document.querySelector(".custom-product-form-status");
let atcButton = document.querySelector(".mrk-btns-container");
let totalSteps = document.querySelector(".custom-product-form-label").getAttribute("data-steps");
let formLabelHeading = document.querySelector(".custom-product-form-label");
let step2Label = document.querySelector(".step_2_label");
nextButton.addEventListener("click", () => {
  if (!nextButton.classList.contains("disabled")) {
    if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        step2.classList.remove("hidden");
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }          
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }
        step2.querySelector(".custom-product-form-summary").click();
        nextButton.classList.add("disabled");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
          nextButton.innerHTML = "Next: Confirm Your Order Details";
        }
        else if (totalSteps == "2") {
          formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
        }
      }
    }
    else if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        if (step2.querySelector("details").getAttribute("open") != null) {
          step2.querySelector(".custom-product-form-summary").click();
        }
        
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }

        //Ak-dd custom code
        step3.classList.remove("hidden");
        if (step3.querySelector("details").getAttribute("open") == null) {
          step3.querySelector(".custom-product-form-summary").click();
        }
        
        // const popup_btn = step3.querySelector("details .mrk-open-popup");
        // if(popup_btn){
        //   window.mrknavigateTo(0);
        //   popup_btn.click();
        // }
        window.mrknavigateTo(1);
        const customizer_popup_footer = document.querySelector(".mrk-product-csutomizer .mrk-steps-footer");
        if(customizer_popup_footer){
          customizer_popup_footer.classList.remove('hidden');
        }
        //End Ak-dd Custom code
        
        nextButton.classList.add("disabled");
        nextButton.classList.add("hidden");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 3 of 3: Finalise Your Order"
        }
      }
    }
  }
  else if (nextButton.classList.contains("disabled")) {
    if (!document.querySelectorAll(".custom-product-form-tick")[0].classList.contains("selected")) {
      statusEl.innerHTML = "Looks like you missed a step—choose your colour to proceed."
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[1].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose a size to proceed with your order."
      if (step2.querySelector("details").getAttribute("open") == null) {
        step2.querySelector(".custom-product-form-summary").click();
      }
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[2].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose an option to continue."
    }
  }
})

newnextButton.addEventListener("click", () => {
  if (!newnextButton.classList.contains("disabled")) {
    if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        step2.classList.remove("hidden");
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }          
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }
        step2.querySelector(".custom-product-form-summary").click();
        newnextButton.classList.add("disabled");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
          newnextButton.innerHTML = "Next: Confirm Your Order Details";
        }
        else if (totalSteps == "2") {
          formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
        }
      }
    }
    else if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        if (step2.querySelector("details").getAttribute("open") != null) {
          step2.querySelector(".custom-product-form-summary").click();
        }
        
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }

        //Ak-dd custom code
        // step3.classList.remove("hidden");
        // if (step3.querySelector("details").getAttribute("open") == null) {
        //   step3.querySelector(".custom-product-form-summary").click();
        // }
        const popup_btn = step3.querySelector("details .mrk-open-popup");
        if(popup_btn){
          window.mrknavigateTo(0);
          popup_btn.click();
        }
        //End Ak-dd Custom code
        
        // newnextButton.classList.add("disabled");
        // newnextButton.classList.add("hidden");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 3 of 3: Finalise Your Order"
        }
      }
        //Ak-dd custom code
      else{
        const popup_btn = step3.querySelector("details .mrk-open-popup");
        if(popup_btn){
          window.mrknavigateTo(0);
          popup_btn.click();
        }
      }
      //End Ak-dd Custom code
    }
  }
  else if (newnextButton.classList.contains("disabled")) {
    if (!document.querySelectorAll(".custom-product-form-tick")[0].classList.contains("selected")) {
      statusEl.innerHTML = "Looks like you missed a step—choose your colour to proceed."
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[1].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose a size to proceed with your order."
      if (step2.querySelector("details").getAttribute("open") == null) {
        step2.querySelector(".custom-product-form-summary").click();
      }
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[2].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose an option to continue."
    }
  }
})

let quantityInputs = document.querySelectorAll(".mrk-qty-item");
let allPlusButtons = document.querySelectorAll('div[data-action="increment"]');
let allMinusButtons = document.querySelectorAll('div[data-action="decrement"]');

function checkQuantities() {
  let hasNonZeroQuantity = false;
  let selectedSizes = []; // Store selected sizes

  quantityInputs.forEach(input => {
    let variantOuter = input.closest(".variant-outer");

    if (!variantOuter.classList.contains("hidden")) {
      // console.log(variantOuter)
      let quantity = parseInt(input.value);

      if (quantity > 0) {
        hasNonZeroQuantity = true;
        let sizeName = variantOuter.querySelector(".variant-outer--title span").textContent.trim();
        selectedSizes.push(sizeName); // Add size to the list
      }
    }
  });

  if (hasNonZeroQuantity) {
    // console.log("✅ Selected Sizes: ", selectedSizes.join(", "));

    nextButton.classList.remove("disabled");
    newnextButton.classList.remove('disabled');
    statusEl.innerHTML = "";
    step2.querySelector(".custom-product-form-tick").classList.add("selected");

    let showATC = true;
    if (step1 && !step1.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }
    if (step2 && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }
    if (step3 && !step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }

    if (showATC) {
      atcButton.classList.remove("hidden");
      // nextButton.classList.add("hidden");
      newnextButton.classList.add('hidden');
    }

    if (selectedSizes.length < 2) {
      step2Label.innerHTML = `Selected Size: ${selectedSizes}`;
    }
    else if (selectedSizes.length > 1) {
      step2Label.innerHTML = `Selected Sizes: ${selectedSizes}`;
    }


  } else {
    // console.log("⚠️ No sizes selected. Please choose at least one.");

    nextButton.classList.add("disabled");
    newnextButton.classList.add('disabled');
    statusEl.innerHTML = "Please choose a size to proceed with your order.";

    if (step2.querySelector("details").getAttribute("open") == null) {
      step2.querySelector(".custom-product-form-summary").click();
    }

    step2.querySelector(".custom-product-form-tick").classList.remove("selected");
    atcButton.classList.add("hidden");
    // nextButton.classList.remove("hidden");
    newnextButton.classList.remove('hidden');
    step2Label.innerHTML = "Select Your Size";
    if (totalSteps == "3") {
      console.log('hihih');
      formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
      nextButton.innerHTML = "Next: Confirm Your Order Details";
      // nextButton.innerHTML = "Add Logos / Add to Cart";
      newnextButton.innerHTML = "Add Logos / Add to Cart";
    }
    else if (totalSteps == "2") {
      formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
    }
  }
}


allPlusButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    setTimeout(() => {
      checkQuantities();
    }, 250);
  })
})

allMinusButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    setTimeout(() => {
      checkQuantities();
    }, 250);
  })
})


// Add event listener to each quantity input
quantityInputs.forEach(input => {
  input.addEventListener("input", checkQuantities);
});

//Ak-dd custom code
const no_add_to_cart_popup = document.querySelector(".mrk-customizer-popup-form .mrk-next-custom-no-cart.mrk-no-add-to-cart");
if(no_add_to_cart_popup){
  no_add_to_cart_popup.addEventListener('click',function(){
    const logoRowButtonNo = document.querySelector(".custom-product-form-logo-row-column-no");
    if(logoRowButtonNo){
      $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
      logoRowButtonNo.click();
    }
  });
}

let logoRowButtonNo = document.querySelector(".custom-product-form-logo-row-column-no");
logoRowButtonNo.addEventListener("click", () => {
  logoRowButtonNo.classList.add("selected");
  step3.querySelector(".custom-product-form-tick").classList.add("selected");
  // step3.querySelector(".custom-product-form-summary").click();
  // nextButton.classList.add("hidden")
  // newnextButton.classList.add('hidden');
  let hasNonZeroQuantity = false;

  quantityInputs.forEach(input => {
    if (!input.closest(".variant-outer").classList.contains("hidden")) {
      if (parseInt(input.value) > 0) {
        hasNonZeroQuantity = true;
      }
    }
  });

  if (hasNonZeroQuantity) {
    // console.log("✅ At least one size has a quantity greater than 0."); // Action B
    nextButton.classList.remove("disabled");
    newnextButton.classList.remove('disabled');
    statusEl.innerHTML = "";
    step2.querySelector(".custom-product-form-tick").classList.add("selected");
    let showATC = true;
    if (step1) {
      if (!step1.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        showATC = false;
      }
    }
    if (step2) {
      if (!step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        showATC = false;
      }
    }
    if (step3) {
      if (!step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        showATC = false;
      }
    }
    if (showATC) {
      document.querySelector(".single-product__add-to-cart").click();
    }
  }
  else {
    // console.log("⚠️ All sizes have quantity 0. Please select at least one."); // Action A
    // Perform Action A (e.g., disable button, show error, etc.)
    nextButton.classList.add("disabled");
    newnextButton.classList.add('disabled');
    statusEl.innerHTML = "Please choose a size to proceed with your order.";
    if (step2.querySelector("details").getAttribute("open") == null) {
      step2.querySelector(".custom-product-form-summary").click();
    }
    step2.querySelector(".custom-product-form-tick").classList.remove("selected");
    atcButton.classList.add("hidden");
    // nextButton.classList.remove("hidden");
    newnextButton.classList.remove("hidden");
    if (totalSteps == "3") {
      formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
      nextButton.innerHTML = "Next: Confirm Your Order Details";
      newnextButton.innerHTML = "Next: Confirm Your Order Details";
    }
    else if (totalSteps == "2") {
      formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
    }
  }
})